import React, { PureComponent } from 'react';
import { Alert } from 'reactstrap';

import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';
import { getCurrentUser } from '../../../helpers/storage';

class Topbar extends PureComponent {
  static propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
    changeUserView: PropTypes.func.isRequired,
    viewPageAs: PropTypes.number.isRequired,
    appEnvironment: PropTypes.shape({}).isRequired,
  };

  render() {
    const {
      changeMobileSidebarVisibility,
      changeSidebarVisibility,
      changeUserView,
      viewPageAs,
      appEnvironment,
    } = this.props;

    const currentUser = getCurrentUser();

    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
            />
            <Link className="topbar__logo" to="/dashboard_default" />
            <span className={currentUser.roles.length > 1 ? 'topbar__role' : 'hidden'}>
              <h4 style={{ fontSize: '15px' }}>Ver como:</h4>
              <select
                className="form-control role-selector"
                value={`${viewPageAs}`}
                onChange={e => changeUserView(Number(e.currentTarget.value))}
              >
                {currentUser.roles.map(role => (
                  <option key={`role_${role.role}`} value={role.role}>{role.title}</option>))}
              </select>
            </span>
          </div>
          {
            appEnvironment && appEnvironment.value !== 'Prod' && (
              <div className="topbar__center">
                <span className="topbar__role">
                  <Alert color="danger" style={{ backgroundColor: '#f44336e0' }}>
                    <h5 className="text-white">{appEnvironment.label}</h5>
                  </Alert>
                </span>
              </div>
            )
          }
          <div className="topbar__right">
            <TopbarProfile />
          </div>
        </div>
      </div>
    );
  }
}

export default Topbar;
